import styled from 'styled-components'
import { shade } from 'polished'
import breakpoint from 'styled-components-breakpoint'

export const Container = styled.div`
  padding: 2rem 1rem;
  background-color: ${shade(0.5, '#9F292C')};
  box-sizing: border-box;

  ${breakpoint('tablet')`
    padding: 2rem;
    border-radius: 2rem;
    width: 50%;
  `}
`

export const Data = styled.div`

`

export const Datum = styled.div`
  text-align: center;

  &:not(:last-child) {
    margin-bottom: 2rem;
  }

  ${breakpoint('tablet')`
    text-align: left;
  `}
`

export const Label = styled.span`
  display: block;
  color: white;
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
`

export const Value = styled.p`
  color: white;
  margin: 0;
  margin-bottom: 1rem;
`

export const A = styled.a`
  color: white;
  word-wrap: break-word;
  transition: 0.3s;

  &:hover {
    color: #C83337;
  }
`

export const Heading = styled.h2`
  color: white;
  margin-top: 0;
`
